module.exports = __webpack_public_path__ + "media/polozhenie.e655c57b.mp3";